module.exports = __webpack_public_path__ + "static/media/ic_directorio_seleccionado.0a29ad79.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_directorio_seleccionado.webp
// module id = 178
// module chunks = 1